export default {"src":"/pro/_next/static/media/sky.9a2e13ce.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};